/**
 * @namespace {BX.UI.IconSet}
 */

export const Actions = Object.freeze({
	ARROW_RIGHT: 'arrow-right',
	ARROW_LEFT: 'arrow-left',
	ARROW_TOP: 'arrow-top',
	ARROW_DOWN: 'arrow-down',
	CHEVRON_RIGHT: 'chevron-right',
	CHEVRON_LEFT: 'chevron-left',
	CHEVRON_UP: 'chevron-up',
	CHEVRON_DOWN: 'chevron-down',
	LEFT_SEMICIRCULAR_ANTICLOCKWISE_ARROW_2: 'left-semicircular-anticlockwise-arrow-2',
	EXPAND_1: 'expand-1',
	EXPAND_DIAGONAL: 'expand-diagonal',
	COLLAPSE: 'collapse',
	COLLAPSE_DIAGONAL: 'collapse-diagonal',
	AGENDA_GAP: 'agenda-gap',
	EXPAND_TO_FULL_SCREEN: 'expand-to-full-screen',
	CURVED_ARROW_LEFT: 'curved-arrow-left',
	FORWARD: 'forward',
	FORWARD_2: 'forward-2',
	ARROW_DOWNLOAD: 'arrow-download',
	PAUSE: 'pause',
	STOP: 'stop',
	PLAY: 'play',
	LEFT_SEMICIRCULAR_ANTICLOCKWISE_ARROW_1: 'left-semicircular-anticlockwise-arrow-1',
	DOUBLE_SHEVRONS_RIGHT: 'double-shevrons-right',
	NEXT: 'next',
	DOWNLOAD_3: 'download-3',
	UPLOAD: 'upload',
	SWAP: 'swap',
	SORT: 'sort',
	LEFT_SEMICIRCULAR_ANTICLOCKWISE_ARROW_3: 'left-semicircular-anticlockwise-arrow-3',
	LEFT_SEMICIRCULAR_ANTICLOCKWISE_ARROW_4: 'left-semicircular-anticlockwise-arrow-4',
	DOWNLOAD: 'download',
	DOWNLOAD_2: 'download-2',
	DOWNLOAD_DOUBLE: 'download-double',
	ARROW_TOP_2: 'arrow-top-2',
	CONVERSION_1: 'conversion-1',
	CONVERSION_2: 'conversion-2',
	FORWARD_3: 'forward-3',
	REPLY: 'reply',
	FORWARD_2_1: 'forward-2-1',
	REPLAY_ALL: 'replay-all',
	OPEN_IN_50: 'open-in-50',
	OPEN_IN_40: 'open-in-40',
	OPEN_IN_30: 'open-in-30',
	REFRESH_1: 'refresh-1',
	REFRESH_2: 'refresh-2',
	REFRESH_3: 'refresh-3',
	REFRESH_4: 'refresh-4',
	REDO_1: 'redo-1',
	UNDO_1: 'undo-1',
	REFRESH_5: 'refresh-5',
	REDO_2: 'redo-2',
	REFRESH_6: 'refresh-6',
	REFRESH_7: 'refresh-7',
	REFRESH_8: 'refresh-8',
	SYNC_SETTINGS: 'sync-settings',
	REFRESH_CLOSED: 'refresh-closed',
	REFRESH_10: 'refresh-10',
	CROSS_CIRCLE_50: 'cross-circle-50',
	CROSS_CIRCLE_60: 'cross-circle-60',
	CROSS_CIRCLE_70: 'cross-circle-70',
	CROSS_20: 'cross-20',
	CROSS_25: 'cross-25',
	CROSS_30: 'cross-30',
	CROSS_40: 'cross-40',
	CROSS_45: 'cross-45',
	CROSS_50: 'cross-50',
	CROSS_55: 'cross-55',
	CROSS_60: 'cross-60',
	PLUS_IN_CIRCLE: 'plus-in-circle',
	MINUS_IN_CIRCLE: 'minus-in-circle',
	MINUS_20: 'minus-20',
	MINUS_30: 'minus-30',
	MINUS_40: 'minus-40',
	MINUS_50: 'minus-50',
	MINUS_60: 'minus-60',
	LINE: 'line',
	PLUS_20: 'plus-20',
	PLUS_30: 'plus-30',
	PLUS_40: 'plus-40',
	PLUS_50: 'plus-50',
	PLUS_60: 'plus-60',
	MORE_9_CUBES: 'more-9-cubes',
	MORE_9_CUBES_2: 'more-9-cubes-2',
	CUBES_4_1: '4-cubes-1',
	CUBES_4_2: '4-cubes-2',
	MORE: 'more',
	SETTINGS_1: 'settings-1',
	SETTINGS_2: 'settings-2',
	SETTINGS_3: 'settings-3',
	SETTINGS_4: 'settings-4',
	COPY_PLATES: 'copy-plates',
	PLATES: 'plates',
	NUMERABLE_LIST: 'numerable-list',
	LINES: 'lines',
	PENCIL_DRAW: 'pencil-draw',
	PENCIL_60: 'pencil-60',
	PENCIL_50: 'pencil-50',
	PENCIL_40: 'pencil-40',
	BRUSH: 'brush',
	PEN: 'pen',
	KEYBOARD: 'keyboard',
	KEYBOARD_2: 'keyboard-2',
	CONNECTION: 'connection',
	DISCONNECTION: 'disconnection',
	IMAGE_ROTATE_LEFT: 'image-rotate-left',
	IMAGE_ROTATE_RIGHT: 'image-rotate-right',
	ZOOM_IN: 'zoom-in',
	ZOOM_OUT: 'zoom-out',
});

export const Social = Object.freeze({
	CLOUD_SIFRE: 'cloud-sifre',
	SKYPE: 'skype',
	VK_LISTS: 'vk-lists',
	TELEGRAM_IN_CIRCLE_1: 'telegram-in-circle-1',
	TELEGRAM: 'telegram',
	TELEGRAM_IN_CIRCLE: 'telegram-in-circle',
	INSTAGRAM: 'instagram',
	INSTAGRAM_FACEBOOK: 'instagram-facebook',
	INSTAGRAM_DIRECT: 'instagram-direct',
	SNOWFLAKE: 'snowflake',
	GLOBE: 'globe',
	FACEBOOK: 'facebook',
	FACEBOOK_CHATS: 'facebook-chats',
	VK: 'vk',
	VIBER: 'viber',
	AVITO: 'avito',
	ODNOKLASSNIKI: 'odnoklassniki',
	WHATSAPP: 'whatsapp',
	SHAPE_1: 'shape-1',
	KIK: 'kik',
	SLACK: 'slack',
	MESSENGER_META: 'messenger-meta',
	MESSENGER: 'messenger',
	VK_SHOP: 'vk-shop',
	WINDOWS: 'windows',
	CALL_INFOMATION: 'call-infomation',
	EVERNOTE: 'evernote',
	GOOGLE_ADS: 'google-ads',
	SHAPE: 'shape',
	WINDOW_SCREEN: 'window-screen',
	EDNA: 'edna',
	CHATS_24: 'chats-24',
	CHATS_COMPUTER: 'chats-computer',
	APPLE_AND_IOS: 'apple-and-ios',
	ANDROID: 'android',
	ZOOM: 'zoom',
	LINUX: 'linux',
});

export const Main = Object.freeze({
	PERSON_LOCATION: 'person-location',
	PERSONS_HAND: 'persons-hand',
	PERSON_ARROW_DOWN: 'person-arrow-down',
	PERSON: 'person',
	PERSON_CAMERA: 'person-camera',
	PERSON_PLUS: 'person-plus',
	PERSONS_DENY: 'persons-deny',
	PERSON_CLOCK: 'person-clock',
	PERSON_CLOCK_2: 'person-clock-2',
	PERSONS_2: 'persons-2',
	PERSONS_3: 'persons-3',
	PERSON_LETTER: 'person-letter',
	PERSON_MESSAGE: 'person-message',
	PERSON_ARROW_LEFT_1: 'person-arrow-left-1',
	PERSON_ARROW_RIGHT: 'person-arrow-right',
	PERSON_ARROW_LEFT_2: 'person-arrow-left-2',
	PERSON_FLAG: 'person-flag',
	PERSON_HANDSET: 'person-handset',
	PERSON_MESSAGE_ARROW_1: 'person-message-arrow-1',
	PERSON_CHECK: 'person-check',
	PERSON_MESSAGE_ARROW_2: 'person-message-arrow-2',
	PERSONS_STORAGE: 'persons-storage',
	PERSON_CALL: 'person-call',
	PERSON_PHONE: 'person-phone',
	PERSON_DESCENDING: 'person-descending',
	PERSON_3_STICKS: 'person-3-sticks',
	PERSON_2_CHECKS: 'person-2-checks',
	PERSON_PLUS_3: 'person-plus-3',
	CLOUD_SYNC: 'cloud-sync',
	CLOUD_TRANSFER_DATA: 'cloud-transfer-data',
	CLOUD_PAUSE: 'cloud-pause',
	CLOUD_ERROR: 'cloud-error',
	CLOUD_CLOCK: 'cloud-clock',
	CLOUD_EMPTY: 'cloud-empty',
	CLOUD_CLOUD: 'cloud-cloud',
	CLOUD_LETTER_POST: 'cloud-letter-post',
	CLOUD_SSO: 'cloud-sso',
	TELEPHONY_HANDSET_1: 'telephony-handset-1',
	TELEPHONY_HANDSET_2: 'telephony-handset-2',
	TELEPHONY_HANDSET_3: 'telephony-handset-3',
	TELEPHONY_HANDSET_4: 'telephony-handset-4',
	TELEPHONY_HANDSET_5: 'telephony-handset-5',
	TELEPHONY_HANDSET_6: 'telephony-handset-6',
	OUTGOING_CALL: 'outgoing-call',
	INCOMING_CALL: 'incoming-call',
	TELEPHONY_PHONEBOOK: 'telephony-phonebook',
	telephony_phonebook_2: 'telephony-phonebook-2',
	CALL_CHAT: 'call-chat',
	CHATS_1: 'chats-1',
	CHATS_2: 'chats-2',
	CHAT_MESSAGE: 'chat-message',
	CHATS_WITH_CHECK: 'chats-with-check',
	CHATS_3: 'chats-3',
	MESSAGE_CHAT_WITH_POINT: 'message-chat-with-point',
	MESSAGE_CHAT_WITH_ARROW: 'message-chat-with-arrow',
	CHAT_BUTTON: 'chat-button',
	FEEDBACK: 'feedback',
	ADD_CHAT: 'add-chat',
	BOOKMARK_1: 'bookmark-1',
	FOLDER_CURVED_ARROW: 'folder-curved-arrow',
	FOLDER_24: 'folder-24',
	FOLDER_PLUS: 'folder-plus',
	FOLDER_EMPTY: 'folder-empty',
	FOLDER_LEFT_ARROW: 'folder-left-arrow',
	FOLDER_INFO: 'folder-info',
	FOLDER_RIGHT_ARROW: 'folder-right-arrow',
	NOTE_CIRCLE: 'note-circle',
	WARNING_CIRCLE: 'warning-circle',
	INFO_CIRCLE: 'info-circle',
	WARNING: 'warning',
	WARNING_ALARM: 'warning-alarm',
	INFO: 'info',
	HELP: 'help',
	SMS: 'sms',
	FILE: 'file',
	LIST: 'list',
	BLACK_LIST: 'black-list',
	SHIELD_2_PLAIN: 'shield-2-plain',
	SHIELD_2_CONTOUR: 'shield-2-contour',
	SHIELD_2_CHECKED: 'shield-2-checked',
	SHIELD_2_ATTENTION: 'shield-2-attention',
	SHIELD_2_MENU: 'shield-2-menu',
	SHIELD_2_TIME: 'shield-2-time',
	SHIELD_2_DEFENDED: 'shield-2-defended',
	SHIELD_2_UPDATE: 'shield-2-update',
	SHIELD_2_CORE_PROBLEM: 'shield-2-core-problem',
	FILE_UPLOAD: 'file-upload',
	FILE_SYNC: 'file-sync',
	FILE_ARROW_TOP: 'file-arrow-top',
	FILE_DELETE: 'file-delete',
	FILE_CHECK: 'file-check',
	FILE_2: 'file-2',
	FILE_DOWNLOAD: 'file-download',
	FILE_ARROW_DOWN: 'file-arrow-down',
	FILE_3: 'file-3',
	HOURGLASS_SANDGLASS: 'hourglass-sandglass',
	CLOCK_1: 'clock-1',
	CLOCK_2: 'clock-2',
	CLOCK_WITH_ARROW: 'clock-with-arrow',
	STOPWATCH: 'stopwatch',
	ALARM: 'alarm',
	BLACK_CLOCK: 'black-clock',
	SPEED_METER: 'speed-meter',
	WATCH: 'watch',
	SMART_PROCESS: 'smart-process',
	SEARCH_1: 'search-1',
	SEARCH_2: 'search-2',
	RESTORE_PASSWORD: 'restore-password',
	TASKS: 'tasks',
	WINDOW_ARROW: 'window-arrow',
	WINDOW_DOUBLE_CHECK_1: 'window-double-check-1',
	WINDOW_RING: 'window-ring',
	WINDOW_DOUBLE_CHECK_2: 'window-double-check-2',
	WINDOW_CHECK_PENCIL: 'window-check-pencil',
	WINDOW_CHECK_LINK: 'window-check-link',
	WINDOW_FLAG: 'window-flag',
	WINDOW_CHECK_WITH_FOLDER: 'window-check-with-folder',
	WINDOW_WITH_POINT: 'window-with-point',
	WINDOW_CHECK_ARROW: 'window-check-arrow',
	VIDEO_1: 'video-1',
	VIDEO_3: 'video-3',
	VIDEO_AND_CHAT: 'video-and-chat',
	NO_VIDEO: 'no-video',
	PICTURE: 'picture',
	MICROPHONE_ON: 'microphone-on',
	CAMERA: 'camera',
	ATTACH_PICTURE: 'attach-picture',
	SOUND_ON: 'sound-on',
	SOUND_OFF: 'sound-off',
	SOUND_2: 'sound-2',
	VIDEO_2: 'video-2',
	SPEAKERPHONE: 'speakerphone',
	HEADSET: 'headset',
	MICROPHONE_OFF: 'microphone-off',
	MUSIC_NOTE_2: 'music-note-2',
	MUSIC_NOTE_3: 'music-note-3',
	MUSIC_NOTE_1: 'music-note-1',
	MARKET_1: 'market-1',
	COPILOT_AI: 'copilot-ai',
	COPILOT_AI_1: 'copilot-ai-1',
	COPILOT_AI_2: 'copilot-ai-2',
	LIST_AI: 'list-ai',
	INFO_CIRCLE_PLUS: 'info-circle-plus',
	SCREEN_BLACK_WHITE: 'screen-black-white',
	BELL_1: 'bell-1',
	HEART: 'heart',
	SYNC_CIRCLE: 'sync-circle',
	LIKE: 'like',
	DISLIKE: 'dislike',
	RULER_AND_PENCIL: 'ruler-and-pencil',
	KEY: 'key',
	MOBILE_2: 'mobile-2',
	LOCK: 'lock',
	PULSE: 'pulse',
	ATTACH: 'attach',
	FLAG_2: 'flag-2',
	FAVORITE_0: 'favorite-0',
	FAVORITE_1: 'favorite-1',
	PULSE_CIRCLE: 'pulse-circle',
	CROWN_2: 'crown-2',
	CROWN_1: 'crown-1',
	HOME: 'home',
	SEND: 'send',
	SUITCASE: 'suitcase',
	SPANNER: 'spanner',
	IDEA_LAMP: 'idea-lamp',
	BOOK_CLOSED: 'book-closed',
	EDIT_PENCIL: 'edit-pencil',
	COMPASS: 'compass',
	CHECK: 'check',
	FUNNEL: 'funnel',
	BRIGHTNESS: 'brightness',
	EARTH_LANGUAGE: 'earth-language',
	OBSERVER: 'observer',
	OBSERVER_CLOSED: 'observer-closed',
	BARCODE_1: 'barcode-1',
	DOOR_OPENED: 'door-opened',
	SHIELD: 'shield',
	TRASH_BIN: 'trash-bin',
	SUNGLASSES: 'sunglasses',
	DEVICE_ROTATE: 'device-rotate',
	PLAY_CIRCLE: 'play-circle',
	CUT: 'cut',
	CIRCLE_MINUS: 'circle-minus',
	CIRCLE_CHECK: 'circle-check',
	CIRCLE_PLUS: 'circle-plus',
	UNAVAILABLE: 'unavailable',
	CALENDAR_2: 'calendar-2',
	LOCATION_1: 'location-1',
	LOCATION_2: 'location-2',
	LOCATION_PLUS: 'location-plus',
	TIME_PICKER: 'time-picker',
	MAP: 'map',
	PIN_2: 'pin-2',
	DOUBLE_RHOMBUS: 'double-rhombus',
	FIRE: 'fire',
	LIGHT_BOLD_SPARKLE: 'light-bold-sparkle',
	LIGHT_BOLD: 'light-bold',
	BOX: 'box',
	DELIVERY_1: 'delivery-1',
	DELIVERY_2: 'delivery-2',
	CUBES_3: 'cubes-3',
	DRAWER: 'drawer',
	CUBE_PLUS: 'cube-plus',
	CALENDAR_SLOTS: 'calendar-slots',
	PAYMENT_TERMINAL: 'payment-terminal',
	CALENDAR_SHARING: 'calendar-sharing',
	TARGET_TIMER: 'target-timer',
	TARGET: 'target',
	MARKET_2: 'market-2',
	BELL: 'bell',
	SALE_TAG: 'sale-tag',
	OPEN_LINES: 'open-lines',
	CHEMISTRY: 'chemistry',
	GRADUATION_CAP: 'graduation-cap',
	PAINT_1: 'paint-1',
	PAINT_2: 'paint-2',
	FLAG_1: 'flag-1',
	CREDIT_DEBIT_CARD: 'credit-debit-card',
	LIGHTNING_PLUS: 'lightning-plus',
	DONATION: 'donation',
	B_24: 'b-24',
	TAG: 'tag',
	SPEAKER_MOUTHPIECE: 'speaker-mouthpiece',
	SPEAKER_MOUTHPIECE_PLUS: 'speaker-mouthpiece-plus',
	OPENED_EYE: 'opened-eye',
	CROSSED_EYE: 'crossed-eye',
	LINKS_3: 'links-3',
	IMPLEMENTATION_REQUEST: 'implementation-request',
	GROUP: 'group',
	DOCUMENT_STREAM: 'document-stream',
	BOOK_OPEN_1: 'book-open-1',
	FOLDERS: 'folders',
	QR_CODE_1: 'qr-code-1',
	QR_CODE_2: 'qr-code-2',
	DESCENDING_SORT: 'descending-sort',
	ASCENDING_SORT: 'ascending-sort',
	CHATS_PERSONS: 'chats-persons',
	MARKETING: 'marketing',
	SIGMA_SUMM_A: 'sigma-summ-a',
	SIGMA_SUMM: 'sigma-summ',
	SMILE: 'smile',
	GANTT_GRAPHS: 'gantt-graphs',
	FILTER_PLUS: 'filter-plus',
	BACKSPACE: 'backspace',
	ELEMENTS: 'elements',
	BOOK_OPENED_WITH_ARROW: 'book-opened-with-arrow',
	DOUBLE_ARROW_COUNTER_CLOCKWISE_SCRUM: 'double-arrow-counter-clockwise-scrum',
	BARCODE: 'barcode',
	SAD_BOLD_EMOJI: 'sad-bold-emoji',
	BRIGHTNESS_BOLD_EMOJI: 'brightness-bold-emoji',
	SUN: 'sun',
	FILIAL_NETWORK: 'filial-network',
	ARROW_LINE: 'arrow-line',
	IP: 'ip',
	FILTER_1: 'filter-1',
	FILTER_2: 'filter-2',
	SCREEN_1: 'screen-1',
	SCREEN_2: 'screen-2',
	PRINT_1: 'print-1',
	PRINT_2: 'print-2',
	DISK: 'disk',
	SHINING: 'shining',
	SHINING_2: 'shining-2',
	PLUG: 'plug',
	PASTE: 'paste',
	CROSSED_EYE_2: 'crossed-eye-2',
	FILTER_BY_NAME: 'filter-by-name',
	DESCENDING_SORT_NAMES: 'descending-sort-names',
	TABLE: 'table',
	FEED: 'feed',
	MOBILE_WITH_STAR: 'mobile-with-star',
	ROCKET: 'rocket',
	CITY: 'city',
	MAGIC_WAND: 'magic-wand',
	MAGIC_IMAGE: 'magic-image',
	AI: 'ai',
	EARTH: 'earth',
	SHARE_1: 'share-1',
	SHARE_2: 'share-2',
	MAIL: 'mail',
	ERASER: 'eraser',
	DEMONSTRATION_ON_1: 'demonstration-on-1',
	DEMONSTRATION_OFF: 'demonstration-off',
	FILE_CHECK_1: 'file-check-1',
	DELETE_HYPERLINK: 'delete-hyperlink',
	INSERT_HYPERLINK: 'insert-hyperlink',
	LINK_3: 'link-3',
	SCREEN_ARROW: 'screen-arrow',
	OPENED_LETTER_MAIL: 'opened-letter-mail',
	SITEMAP: 'sitemap',
	NOTIFICATIONS_ON: 'notifications-on',
	NOTIFICATIONS_OFF: 'notifications-off',
	A_LETTER: 'a-letter',
	TOPIC: 'topic',
	FULL_BATTERY: 'full-battery',
	BATTERY_2_STICKS: 'battery-2-sticks',
	BATTERY_1_STICK: 'battery-1-stick',
	LOW_BATTERY: 'low-battery',
	DEAD_BATTERY: 'dead-battery',
	DOCUMENT_PLUS: 'document-plus',
	DEMONSTRATION_ON_2: 'demonstration-on-2',
	RECEIPT_1: 'receipt-1',
	RECEIPT_2: 'receipt-2',
	CART_WITH_CURSOR: 'cart-with-cursor',
	EXPAND: 'expand',
	GIFT: 'gift',
	MORE_POINTS: 'more-points',
	PIN_1: 'pin-1',
	MORE_INFORMATION: 'more-information',
	MARKERS: 'markers',
	FEED_BOLD: 'feed-bold',
	STOP_HAND: 'stop-hand',
	TARGET_1: 'target-1',
	MAIL_OUT: 'mail-out',
	MAIL_IN: 'mail-in',
	MAIL_MONEY: 'mail-money',
	UNPIN: 'unpin',
	ATTENTION_I_CIRCLE: 'attention-i-circle',
	INFO_1: 'info-1',
	ATTENTION_I_BLACK: 'attention-i-black',
	MENU: 'menu',
	WAVES: 'waves',
	MAIL_REPLY: 'mail-reply',
	MAIL_2: 'mail-2',
	MAIL_READ: 'mail-read',
	QUOTE: 'quote',
	NEW_MESSAGE_MAIL: 'new-message-mail',
	INDENT: 'indent',
	OUTDENT: 'outdent',
	DISTRIBUTION: 'distribution',
	MENU_POINT: 'menu-point',
	LINES_TEXT: 'lines-text',
	DIAMOND: 'diamond',
	BOTTOM: 'bottom',
	NUMBERS_123: 'numbers-123',
	CURSOR_CLICK: 'cursor-click',
	FLAG_WITH_CROSS: 'flag-with-cross',
	TEMP_1: 'temp-1',
	TEMP_2: 'temp-2',
	CALENDAR_1: 'calendar-1',
	CALENDAR_24: 'calendar-24',
	WINDOW: 'window',
	PLANNING: 'planning',
	SORT_CALENDAR: 'sort-calendar',
	CALENDAR_DEADLINE: 'calendar-deadline',
	SORT_ACTIVITY: 'sort-activity',
	PLANNING_2: 'planning-2',
	MY_PLAN: 'my-plan',
	CALENDAR_OFF: 'calendar-off',
	SIGNAL_WIFI: 'signal-wifi',
	SIGNAL_WIFI_OFF: 'signal-wifi-off',
	IMG_FORMAT: 'img-format',
	ATTACH_2: 'attach-2',
	CRM: 'crm',
	APPS: 'apps',
	TEMPLATES: 'templates',
	HR_AUTOMATION: 'hr-automation',
	SITES_STORES: 'sites-stores',
	C1: '1c',
	REFRESH: 'refresh',
	SUBSCRIPTION: 'subscription',
	SETTINGS: 'settings',
	SERVICES: 'services',
	GRAPHS_DIAGRAM: 'graphs-diagram',
	OPEN_BOOK: 'open-book',
	ROBOT: 'robot',
	DEVELOPER_RESOURCES: 'developer-resources',
	CASH_TERMINAL: 'cash-terminal',
	CLOCK_BLACK_WHITE: 'clock-black-white',
	INVENTORY_MANAGEMENT: 'inventory-management',
	COLLABORATION: 'collaboration',
	DOCUMENT: 'document',
	CHECK_RECEIPT: 'check-receipt',
	CALCULATOR: 'calculator',
	SWITCH: 'switch',
	SEQUENTIAL_QUEUE: 'sequential-queue',
	PARALLEL_QUEUE: 'parallel-queue',
	CONDITION: 'condition',
	COMPLETE: 'complete',
	TRANSLATION: 'translation',
	TORRENT: 'torrent',
	ACTIVITY: 'activity',
	ADD_TO_CHECKLIST: 'add-to-checklist',
	BP: 'bp',
	CLOSE_CHAT: 'close-chat',
	CREATE_PROMPT: 'create-prompt',
	DEVICES: 'devices',
	DOCUMENT_SIGN: 'document-sign',
	FAVOURITE_PROMPT: 'favourite-prompt',
	LINES_VERTICAL: 'lines-vertical',
	MAIN: 'main',
	MOVE_TO_CHECKLIST: 'move-to-checklist',
	OPEN_CHAT: 'open-chat',
	PROMPT: 'prompt',
	PROMPT_VAR: 'prompt-var',
	PROMPTS_LIBRARY: 'prompts-library',
	RECORD_VIDEO: 'record-video',
	ROLES_LIBRARY: 'roles-library',
	SAVE_PROMPT: 'save-prompt',
	SCREEN_SHARE: 'screen-share',
	SUB_POINT: 'sub-point',
	UNSUB_POINT: 'unsub-point',
	SUB_TASK: 'subtask',
	COLLAB: 'collab',
	NO_PICTURE: 'no-picture',
	THREAD: 'thread',
	THREAD_SINGLE: 'thread-single',
	BUSINESS_PROCESS_1: 'business-process-1',
	WAITING_POINTS: 'waiting-points',
	WAITING_LIST: 'waiting-list',
	LINK_BOLD: 'link-bold',
	NOTE: 'note',
	EDIT_MENU: 'edit-menu',
	DEMONSTRATION_GRAPHICS: 'demonstration-graphics',
	CALENDAR_CHECK: 'calendar-check',
	SIGN: 'sign',
	FLIPCHART: 'flipchart',
	NUMBERS_05: 'numbers-05',
	DEMONSTRATION_GRAPHICS_2: 'demonstration-graphics-2',
	EARTH_TIME: 'earth-time',
});

export const ContactCenter = Object.freeze({
	DIAL_5: 'dial-5',
	DIAL_10: 'dial-10',
	CALL_FORWARDING: 'call-forwarding',
	MOBILE_STORE: 'mobile-store',
	MAIL_SENT: 'mail-sent',
	INCOMING_CALL_SOUND_ON: 'incoming-call-sound-on',
	SEND_ATTACH_FILE: 'send-attach-file',
});

export const Animated = Object.freeze({
	LOADER_CLOCK: 'loader-clock',
	LOADER_WAIT: 'loader-wait',
});

export const CRM = Object.freeze({
	SEND_CONTACT: 'send-contact',
	BOOK_OPEN: 'book-open',
	funnel_1: 'funnel-1',
	CRM_SEARCH: 'crm-search',
	REFRESH_9: 'refresh-9',
	CHECK_IN_BOX: 'check-in-box',
	ARROWS_MEET: 'arrows-meet',
	CHAT_LINE: 'chat-line',
	COMMERCIAL_OFFER: 'commercial-offer',
	FUNNELS: 'funnels',
	ITEM: 'item',
	PROPOSAL_SETTINGS: 'proposal-settings',
	PROPOSAL_DONE: 'proposal-done',
	PROPOSAL: 'proposal',
	CRM_GROUP: 'crm-group',
	CONTACT: 'contact',
	LEAD: 'lead',
	INVOICE: 'invoice',
	STAGES: 'stages',
	EXCLUSION_LIST: 'exclusion-list',
	OPEN_CHANNELS: 'open-channels',
	APPROVED_LIST: 'approved-list crm-checked_1',
	COMPANY: 'company',
	COPY_FILE: 'copy-file',
	GIRD: 'gird',
	FUNNEL_2: 'funnel-2',
	STAGE: 'stage',
	CUSTOMER_CARD: 'customer-card',
	SMART_ACTIVITIES: 'smart-activities',
	CHOOSE: 'choose',
	ADD_FROM_ADRESSBOOK: 'add-from-adressbook',
	ADD_FILE: 'add-file',
	RECEIVE_PAYMENT_SETTINGS: 'receive-payment-settings',
	TIMELINE: 'timeline',
	FORM_SETTINGS: 'form-settings',
	CUSTOMER_CARDS: 'customer-cards',
	SHOP_LIST: 'shop-list',
	SHOP_SEEN: 'shop-seen',
	ADD_FROM_CRM: 'add-from-crm',
	PAYMENT_AND_DELIVERY: 'payment-and-delivery',
	SMART_SORT: 'smart-sort',
	CART_TEXT: 'cart-text',
	CART: 'cart',
	CART_IMAGE: 'cart-image',
	COMMENT_PLUS: 'comment-plus',
	DEAL_1: 'deal-1',
	DEAL_PLUS_1: 'deal-plus-1',
	TIMELINE_PLUS: 'timeline-plus',
	PLUS_BASED_ON: 'plus-based-on',
	DEAL: 'deal',
	CUSTOMER_CARD_1: 'customer-card-1',
	DEAL_PLUS: 'deal-plus',
	PERSON_PLUS_2: 'person-plus-2',
	CITY_PLUS: 'city-plus',
	CUSTOMER_CARD_PLUS: 'customer-card-plus',
	CHAT_1: 'chat-1',
	DIALOGUE_1: 'dialogue-1',
	BUSINESS_PROCESS: 'business-process',
	FORM: 'form',
	WALLET: 'wallet',
	TAXI: 'taxi',
	INTERCONNECTION: 'interconnection',
	REDUCE: 'reduce',
	DIALOGUE: 'dialogue',
	DELIVERY_CAR: 'delivery-car',
	CAR: 'car',
	CRM_PAYMENT: 'crm-payment',
	INSERT: 'insert',
	CRM_LETTERS: 'crm-letters',
	CRM_MAP: 'crm-map',
	SEND_FILE: 'send-file',
	BITRIX_1C: 'bitrix-1c',
});

export const Editor = Object.freeze({
	BOLD: 'bold',
	ITALIC: 'italic',
	UNDERLINE: 'underline',
	STRIKETHROUGH: 'strikethrough',
	TEXT_COLOR: 'text-color',
	REMOVE_FORMATTING: 'remove-formatting',
	FONT_SIZE: 'font-size',
	NUMBERED_LIST: 'numbered-list',
	BULLETED_LIST: 'bulleted-list',
	LEFT_ALIGN: 'left-align',
	TEXT_AMOUNT: 'text-amount',
	INCERT_IMAGE: 'incert-image',
	INSERT_EMOJI: 'insert-emoji',
	INSERT_SPOILER: 'insert-spoiler',
	REMOVE_FONTSIZE: 'remove-fontsize',
	VIEWMODE_WYSIWYG: 'viewmode-wysiwyg',
	VIEWMODE_CODE: 'viewmode-code',
	VIEWMODE_SPLIT_HOR: 'viewmode-split-hor',
	VIEWMODE_SPLIT_VER: 'viewmode-split-ver',
	UNDO: 'undo',
	REDO: 'redo',
	HEADER: 'header',
	ERASER: 'eraser',
	RULER_AND_PENCIL: 'ruler-and-pencil',
	PAINT_BUCKET: 'paint-bucket',
	SERVICE: 'service',
	TEXT_CHECK: 'text-check',
	PAINT_BUCKET_FORMATTING: 'paint-bucket-formatting',
	NEW_FILE: 'new-file',
	SETTINGS_5: 'settings-5',
	ANCHOR: 'anchor',
	SUPERSCRIPT: 'superscript',
	SUBSCRIPT: 'subscript',
	HR: 'hr',
	SPECIAL_CHARACTERS: 'special-characters',
	CHECK_GRAMMAR: 'check-grammar',
	BREAKS: 'breaks',
	PRINT: 'print',
	UNION: 'union',
	MENTION: 'mention',
	ADD_TAG: 'add-tag',
	ENCLOSE_TEXT_IN_CODE_TAG: 'enclose-text-in-code-tag',
	TABLE_EDITOR: 'table-editor',
	BB_CODE_MODE: 'bb-code-mode',
	FULL_SCREEN: 'full-screen',
	CENTER_ALIGN: 'center-align',
	RIGHT_LIGN: 'right-align',
	JUSTIFY: 'justify',
	DECREASE_INDENT: 'decrease-indent',
	INCREASE_INDENT: 'increase-indent',
	PARAGRAPH_BACKGROUND_COLOUR: 'paragraph-background-colour',
	FORMATTING: 'formatting',
	INSERT_VIDEO: 'insert-video',
	SPEED_0_5: 'speed-0-5',
	SPEED_0_7: 'speed-0-7',
	SPEED_1_0: 'speed-1-0',
	SPEED_1_2: 'speed-1-2',
	SPEED_1_5: 'speed-1-5',
	SPEED_1_7: 'speed-1-7',
	SPEED_2_0: 'speed-2-0',
	MAKE_LONGER: 'make-longer',
	MAKE_SHORTER: 'make-shorter',
});

export const Special = Object.freeze({
	// : '',
});
export const Outline = Object.freeze({
	DOUBLE_GIS: 'o-double-gis',
	THREE_PERSONS: 'o-three-persons',
	A_LETTER: 'o-a-letter',
	ACHIEVEMENT: 'o-achievement',
	ACTIVITY: 'o-activity',
	ADD_CHAT: 'o-add-chat',
	ADD_EVENT: 'o-add-event',
	ADD_FUNNEL: 'o-add-funnel',
	ADD_PERSON: 'o-add-person',
	ADD_PRODUCT: 'o-add-product',
	ADD_TIMELINE: 'o-add-timeline',
	AI_STARS_QUESTION: 'o-ai-stars-question',
	AI_STARS: 'o-ai-stars',
	ALARM: 'o-alarm',
	ALERT_ACCENT: 'o-alert-accent',
	ALERT: 'o-alert',
	ALIGN_CENTER: 'o-align-center',
	ALIGN_JUSTIFY: 'o-align-justify',
	ALIGN_LEFT: 'o-align-left',
	ALIGN_RIGHT: 'o-align-right',
	APPS: 'o-apps',
	ATTACH_2: 'o-attach-2',
	ATTACH: 'o-attach',
	AUTOFILL: 'o-autofill',
	BACK_10: 'o-back-10',
	BACK_15: 'o-back-15',
	BARCODE: 'o-barcode',
	BATTERY_1_STICK: 'o-battery-1-stick',
	BATTERY_2_STICKS: 'o-battery-2-sticks',
	BATTERY_NO_CHARGE: 'o-battery-no-charge',
	BLUETOOTH: 'o-bluetooth',
	BOARD: 'o-board',
	BOLD: 'o-bold',
	BOOKMARK_2: 'o-bookmark-2',
	BOOKMARK: 'o-bookmark',
	BOTTLENECK: 'o-bottleneck',
	BOTTOM_MENU: 'o-bottom-menu',
	BOX_WITH_LID: 'o-box-with-lid',
	BOX: 'o-box',
	BUG: 'o-bug',
	BULLETED_LIST: 'o-bulleted-list',
	BUSINES_PROCESS_STAGES: 'o-busines-process-stages',
	BUSINESS_PROCESS_PROGRESS: 'o-business-process-progress',
	BUSINESS_PROCESS: 'o-business-process',
	CALENDAR_EMPTY: 'o-calendar-empty',
	CALENDAR_SHARE: 'o-calendar-share',
	CALENDAR_WITH_CHECKS: 'o-calendar-with-checks',
	CALENDAR_WITH_SLOTS: 'o-calendar-with-slots',
	CALENDAR: 'o-calendar',
	CAMERA_OFF: 'o-camera-off',
	CAMERA: 'o-camera',
	CARD: 'o-card',
	CASH_TERMINAL: 'o-cash-terminal',
	CHANGE_FUNNEL: 'o-change-funnel',
	CHANGE_ORDER_2: 'o-change-order-2',
	CHANGE_ORDER: 'o-change-order',
	CHAT_LIST: 'o-chat-list',
	CHATS: 'o-chats',
	CHECK_LIST: 'o-check-list',
	CIRCLE_CHECK: 'o-circle-check',
	CIRCLE_CROSS: 'o-circle-cross',
	CIRCLE_MINUS: 'o-circle-minus',
	CIRCLE_MORE: 'o-circle-more',
	CIRCLE_PLUS: 'o-circle-plus',
	CLOCK_BACK: 'o-clock-back',
	CLOCK: 'o-clock',
	CLOSE_CHAT: 'o-close-chat',
	CLOUD_DOWNLOAD: 'o-cloud-download',
	CLOUD_SYNC: 'o-cloud-sync',
	CLOUD_TIME: 'o-cloud-time',
	CLOUD_WITH_CHECK: 'o-cloud-with-check',
	CLOUD: 'o-cloud',
	COLLAB: 'o-collab',
	COLLABORATION: 'o-collaboration',
	COLUMNS_SIDEBAR_PENDING: 'o-columns-sidebar-pending',
	COLUMNS: 'o-columns',
	COMPANY: 'o-company',
	COMPLETE_TASK_LIST: 'o-complete-task-list',
	CONTACT: 'o-contact',
	COPILOT: 'o-copilot',
	COPY: 'o-copy',
	CREATE_CHAT: 'o-create-chat',
	CREATE_FILE: 'o-create-file',
	CRM_LETTERS: 'o-crm-letters',
	CRM: 'o-crm',
	CROSSED_EYE: 'o-crossed-eye',
	CROWN: 'o-crown',
	CURSOR_CLICK: 'o-cursor-click',
	CURSORS_STRIKE: 'o-cursors-strike',
	DAY_OFF: 'o-day-off',
	DELAY: 'o-delay',
	DELEGATE: 'o-delegate',
	DELIVERY: 'o-delivery',
	DEMONSTRATION_ON: 'o-demonstration-on',
	DEPARTMENT: 'o-department',
	DESIGN: 'o-design',
	DEVELOPER_RESOURCES: 'o-developer-resources',
	DEVICE_ROTATE: 'o-device-rotate',
	DISK_SHARED: 'o-disk-shared',
	DISLIKE: 'o-dislike',
	DISTRIBUTION: 'o-distribution',
	DOCUMENT_UPDATE: 'o-document-update',
	DOUBLE_CHECK: 'o-double-check',
	DOWNLOAD: 'o-download',
	DUPLICATE: 'o-duplicate',
	EARTH_WITH_CHECK: 'o-earth-with-check',
	EARTH_WITH_CLOCK: 'o-earth-with-clock',
	EARTH_WITH_CROSS: 'o-earth-with-cross',
	EARTH_WITH_STOP: 'o-earth-with-stop',
	EARTH_WITH_TREE: 'o-earth-with-tree',
	EARTH: 'o-earth',
	EMPTY_BATTERY: 'o-empty-battery',
	EMPTY_MESSAGE: 'o-empty-message',
	ENTERPRISE: 'o-enterprise',
	EXPERT_MODE: 'o-expert-mode',
	FAVORITE: 'o-favorite',
	FEEDBACK: 'o-feedback',
	FILE_WITH_CHECK_2: 'o-file-with-check-2',
	FILE_WITH_CHECK: 'o-file-with-check',
	FILE_WITH_CLOCK: 'o-file-with-clock',
	FILE: 'o-file',
	FILTER_2_LINES: 'o-filter-2-lines',
	FILTER_FUNNEL: 'o-filter-funnel',
	FILTER: 'o-filter',
	FIND_FILTERS: 'o-find-filters',
	FIRE: 'o-fire',
	FIRE_SOLID: 'o-fire-solid',
	FLAG_WITH_CROSS: 'o-flag-with-cross',
	FLAG: 'o-flag',
	FOLDER_24: 'o-folder-24',
	FOLDER_PLUS: 'o-folder-plus',
	FOLDER_SUCCESS: 'o-folder-success',
	FOLDER_WITH_CARD: 'o-folder-with-card',
	FOLDER: 'o-folder',
	FORM: 'o-form',
	FORWARD_10: 'o-forward-10',
	FORWARD_15: 'o-forward-15',
	FORWARD: 'o-forward',
	FREELANCE: 'o-freelance',
	FULL_BATTERY: 'o-full-battery',
	GIFT: 'o-gift',
	GLASSES: 'o-glasses',
	GLOBE_EXTRANET: 'o-globe-extranet',
	GO_TO_MESSAGE: 'o-go-to-message',
	GOOGLE_MAPS: 'o-google-maps',
	GRADUATION_CAP: 'o-graduation-cap',
	GRAPHS_DIAGRAM: 'o-graphs-diagram',
	GROUP: 'o-group',
	HAMBURGER_MENU: 'o-hamburger-menu',
	HANDSHAKE: 'o-handshake',
	HEADSET: 'o-headset',
	HEART: 'o-heart',
	HIGH_TEMPERATURE: 'o-high-temperature',
	HOME_STAR: 'o-home-star',
	HOME: 'o-home',
	HOURGLASS: 'o-hourglass',
	IDEA_LAMP: 'o-idea-lamp',
	IMAGE: 'o-image',
	INFO_CIRCLE: 'o-info-circle',
	INTERVAL: 'o-interval',
	INTRANET: 'o-intranet',
	INVENTORY_MANAGEMENT: 'o-inventory-management',
	INVOICE: 'o-invoice',
	ISSUE_INVOICE: 'o-issue-invoice',
	ITALIC: 'o-italic',
	KANBAN: 'o-kanban',
	KEY: 'o-key',
	KNOWLEDGE_BASE: 'o-knowledge-base',
	LAYERS: 'o-layers',
	LEAD: 'o-lead',
	LEFT_RIGHT: 'o-left-right',
	LIKE: 'o-like',
	LINK_SETTINGS: 'o-link-settings',
	LINK: 'o-link',
	LINKS_LIST: 'o-links-list',
	LOCATION_TIME: 'o-location-time',
	LOCATION: 'o-location',
	LOG_IN: 'o-log-in',
	LOG_OUT: 'o-log-out',
	LOWER_RIGHT_ARROW: 'o-lower-right-arrow',
	MAGIC_WAND: 'o-magic-wand',
	MAIL_COUNTER: 'o-mail-counter',
	MAIL_FORWARD: 'o-mail-forward',
	MAIL_IN_PROGRESS: 'o-mail-in-progress',
	MAIL_OPEN: 'o-mail-open',
	MAIL_RETURN: 'o-mail-return',
	MAIL_SEND: 'o-mail-send',
	MAIL: 'o-mail',
	MAIN_TOOL: 'o-main-tool',
	MAP: 'o-map',
	MARKET: 'o-market',
	MAXIMIZE: 'o-maximize',
	MEETING_POINT: 'o-meeting-point',
	MENTION: 'o-mention',
	MESSAGE: 'o-message',
	MESSAGES: 'o-messages',
	MESSENGER_META: 'o-messenger-meta',
	MESSENGER: 'o-messenger',
	MICROPHONE_OFF: 'o-microphone-off',
	MICROPHONE_ON: 'o-microphone-on',
	MINIMIZE: 'o-minimize',
	MOBILE_CONSTRUCTOR: 'o-mobile-constructor',
	MOBILE_SERVICE: 'o-mobile-service',
	MOBILE_STARS: 'o-mobile-stars',
	MOBILE: 'o-mobile',
	MODERATOR: 'o-moderator',
	MONEY: 'o-money',
	MOON: 'o-moon',
	MOVE_TO_CHECKLIST: 'o-move-to-checklist',
	MOVE_TO: 'o-move-to',
	MULTICHOICE_OFF: 'o-multichoice-off',
	MULTICHOICE_ON: 'o-multichoice-on',
	MUSIC: 'o-music',
	MY_DEALS: 'o-my-deals',
	MY_PLAN: 'o-my-plan',
	NEUTRAL: 'o-neutral',
	NEW_MESSAGE: 'o-new-message',
	NEWSFEED: 'o-newsfeed',
	NEXT: 'o-next',
	NO_WIFI: 'o-no-wifi',
	NON_FAVORITE: 'o-non-favorite',
	NOTE: 'o-note',
	NOTIFICATION_OFF: 'o-notification-off',
	NOTIFICATION_SETTINGS: 'o-notification-settings',
	NOTIFICATION_WITH_CROSS: 'o-notification-with-cross',
	NOTIFICATION: 'o-notification',
	NUMBERED_LIST: 'o-numbered-list',
	OBSERVER: 'o-observer',
	ONLINE_BOOKING: 'o-online-booking',
	OPEN_CHANNELS: 'o-open-channels',
	OPEN_CHAT: 'o-open-chat',
	CHATS_WITH_CHECK: 'o-chats-with-check',
	REPLY: 'o-reply',
	PACKAGE: 'o-package',
	PALETTE: 'o-palette',
	PARTNER_NFC: 'o-partner-nfc',
	PATH: 'o-path',
	PAYMENT_TERMINAL: 'o-payment-terminal',
	PAYMENT: 'o-payment',
	PERSON_CHECKS: 'o-person-checks',
	PERSON_DESCENDING: 'o-person-descending',
	PERSON_SEARCH: 'o-person-search',
	PERSON_SETTINGS: 'o-person-settings',
	PERSON_SPEAK: 'o-person-speak',
	PERSON: 'o-person',
	PHONE_ADD: 'o-phone-add',
	PHONE_BROKEN: 'o-phone-broken',
	PHONE_DOWN: 'o-phone-down',
	PHONE_IN: 'o-phone-in',
	PHONE_OUT: 'o-phone-out',
	PHONE_UP: 'o-phone-up',
	PIN_LIST: 'o-pin-list',
	PIN: 'o-pin',
	PING: 'o-ping',
	PITCH_ZOOM: 'o-pitch-zoom',
	PLANNING: 'o-planning',
	POINT_LEFT: 'o-point-left',
	POINT_RIGHT: 'o-point-right',
	POWER: 'o-power',
	PRINTER: 'o-printer',
	PROCESSES: 'o-processes',
	PRODUCT: 'o-product',
	PROMPT_LIBRARY: 'o-prompt-library',
	PROMPT_VAR: 'o-prompt-var',
	PULSE: 'o-pulse',
	QR_CODE: 'o-qr-code',
	QUANTITY: 'o-quantity',
	QUESTION_L: 'o-question-l',
	QUESTION: 'o-question',
	QUOTE: 'o-quote',
	RECORD_VIDEO: 'o-record-video',
	REDO: 'o-redo',
	REFRESH: 'o-refresh',
	RELATED_TASKS: 'o-related-tasks',
	REMOVE_PERSON: 'o-remove-person',
	REPEAT_CYCLE: 'o-repeat-cycle',
	REPEAT_SALES: 'o-repeat-sales',
	REPEAT: 'o-repeat',
	RESUME: 'o-resume',
	ROBOT: 'o-robot',
	ROCKET: 'o-rocket',
	RUNNING_MAN: 'o-running-man',
	SAD: 'o-sad',
	SALE_TAG: 'o-sale-tag',
	SCREEN: 'o-screen',
	SCRUM: 'o-scrum',
	SEARCH: 'o-search',
	SEND: 'o-send',
	SENDED: 'o-sended',
	SERVICES: 'o-services',
	SET_COLUMNS: 'o-set-columns',
	SETTINGS: 'o-settings',
	SHARE_TASK: 'o-share-task',
	SHARE: 'o-share',
	SHIELD_ATTENTION: 'o-shield-attention',
	SHIELD_CHECKED: 'o-shield-checked',
	SHIELD: 'o-shield',
	SHOPPING_CART: 'o-shopping-cart',
	SHUFFLE: 'o-shuffle',
	SICK: 'o-sick',
	SIGMA_SUMM: 'o-sigma-summ',
	SIGN: 'o-sign',
	SMART_ACTIVITY: 'o-smart-activity',
	SMART_PROCESS: 'o-smart-process',
	SMILE: 'o-smile',
	SMS: 'o-sms',
	SORT_ACTIVITY: 'o-sort-activity',
	SORT_CALENDAR: 'o-sort-calendar',
	SOUND_OFF: 'o-sound-off',
	SOUND_ON: 'o-sound-on',
	SPEAKER: 'o-speaker',
	SPEED_0_5: 'o-speed-0_5',
	SPEED_0_7: 'o-speed-0_7',
	SPEED_1: 'o-speed-1',
	SPEED_1_2: 'o-speed-1_2',
	SPEED_1_5: 'o-speed-1_5',
	SPEED_1_7: 'o-speed-1_7',
	SPEED_2: 'o-speed-2',
	SPEED_METER: 'o-speed-meter',
	SPORT_MARATHON: 'o-sport-marathon',
	STAGE_MINUS: 'o-stage-minus',
	STAGE_PLUS: 'o-stage-plus',
	STAGE: 'o-stage',
	STAGES: 'o-stages',
	STOCK: 'o-stock',
	STOP_HAND_CROSSED: 'o-stop-hand-crossed',
	STOP_HAND: 'o-stop-hand',
	STORAGE: 'o-storage',
	STRESS: 'o-stress',
	STRIKETHROUGH: 'o-strikethrough',
	STRUCTURE_HORIZONTAL: 'o-structure-horizontal',
	STRUCTURE_VERTICAL: 'o-structure-vertical',
	SUBTASK: 'o-subtask',
	SUITCASE: 'o-suitcase',
	SUN: 'o-sun',
	SWITCH_CAMERA: 'o-switch-camera',
	SWITCHER: 'o-switcher',
	TABLET: 'o-tablet',
	TAG: 'o-tag',
	TARIFF_SCANER: 'o-tariff-scaner',
	TASK_LIST: 'o-task-list',
	TASK: 'o-task',
	TELEGRAM: 'o-telegram',
	TELEPHONY: 'o-telephony',
	TEXT: 'o-text',
	THEME: 'o-theme',
	THREAD_SINGLE: 'o-thread-single',
	THREAD: 'o-thread',
	TIMELINE: 'o-timeline',
	TIMER_DOT: 'o-timer-dot',
	TIMER: 'o-timer',
	TOPIC: 'o-topic',
	TRANSLATION: 'o-translation',
	TRASHCAN: 'o-trashcan',
	TREND_DOWN: 'o-trend-down',
	TREND_UP: 'o-trend-up',
	UNDERLINE: 'o-underline',
	UNDO: 'o-undo',
	UNLINK: 'o-unlink',
	UNPIN: 'o-unpin',
	UPLOAD_DOCUMENT: 'o-upload-document',
	UPLOAD_FILE: 'o-upload-file',
	UPLOAD: 'o-upload',
	USER_MASK: 'o-user-mask',
	VACATION: 'o-vacation',
	WALLET: 'o-wallet',
	WHATSAPP: 'o-whatsapp',
	WIFI: 'o-wifi',
	WINDOW_FLAG: 'o-window-flag',
	WINDOW_RING: 'o-window-ring',
	YANDEX_MAPS: 'o-yandex-maps',
	ZOOM_IN: 'o-zoom-in',
	ZOOM_OUT: 'o-zoom-out',
	ARROW_DOWN_L: 'arrow-down-l',
	ARROW_DOWN_M: 'arrow-down-m',
	ARROW_DOWN_S: 'arrow-down-s',
	ARROW_DOWN_XS: 'arrow-down-xs',
	ARROW_LEFT_L: 'arrow-left-l',
	ARROW_LEFT_M: 'arrow-left-m',
	ARROW_LEFT_S: 'arrow-left-s',
	ARROW_LEFT_XS: 'arrow-left-xs',
	ARROW_RIGHT_L: 'arrow-right-l',
	ARROW_RIGHT_M: 'arrow-right-m',
	ARROW_RIGHT_S: 'arrow-right-s',
	ARROW_RIGHT_XS: 'arrow-right-xs',
	ARROW_TOP_L: 'arrow-top-l',
	ARROW_TOP_M: 'arrow-top-m',
	ARROW_TOP_S: 'arrow-top-s',
	ARROW_TOP_XS: 'arrow-top-xs',
	BAN_L: 'ban-l',
	BAN_M: 'ban-m',
	BAN_S: 'ban-s',
	BAN_XS: 'ban-xs',
	CHECK_L: 'check-l',
	CHECK_M: 'check-m',
	CHECK_S: 'check-s',
	CHECK_XS: 'check-xs',
	CHEVRON_DOWN_L: 'chevron-down-l',
	CHEVRON_DOWN_M: 'chevron-down-m',
	CHEVRON_DOWN_S: 'chevron-down-s',
	CHEVRON_DOWN_XS: 'chevron-down-xs',
	CHEVRON_LEFT_L: 'chevron-left-l',
	CHEVRON_LEFT_M: 'chevron-left-m',
	CHEVRON_LEFT_S: 'chevron-left-s',
	CHEVRON_LEFT_XS: 'chevron-left-xs',
	CHEVRON_RIGHT_L: 'chevron-right-l',
	CHEVRON_RIGHT_M: 'chevron-right-m',
	CHEVRON_RIGHT_S: 'chevron-right-s',
	CHEVRON_RIGHT_XS: 'chevron-right-xs',
	CHEVRON_TOP_L: 'chevron-top-l',
	CHEVRON_TOP_M: 'chevron-top-m',
	CHEVRON_TOP_S: 'chevron-top-s',
	CHEVRON_TOP_XS: 'chevron-top-xs',
	COLLAPSE_L: 'collapse-l',
	COLLAPSE_M: 'collapse-m',
	COLLAPSE_S: 'collapse-s',
	COLLAPSE_XS: 'collapse-xs',
	CROSS_L: 'cross-l',
	CROSS_M: 'cross-m',
	CROSS_S: 'cross-s',
	CROSS_XS: 'cross-xs',
	DRAG_L: 'drag-l',
	DRAG_M: 'drag-m',
	DRAG_S: 'drag-s',
	DRAG_XS: 'drag-xs',
	EDIT_L: 'edit-l',
	EDIT_M: 'edit-m',
	EDIT_S: 'edit-s',
	EDIT_XS: 'edit-xs',
	EXPAND_L: 'expand-l',
	EXPAND_M: 'expand-m',
	EXPAND_S: 'expand-s',
	EXPAND_XS: 'expand-xs',
	FILTER_2_L: 'filter-2-l',
	FILTER_2_M: 'filter-2-m',
	FILTER_2_S: 'filter-2-s',
	FILTER_2_XS: 'filter-2-xs',
	GO_TO_L: 'go-to-l',
	GO_TO_M: 'go-to-m',
	GO_TO_S: 'go-to-s',
	GO_TO_XS: 'go-to-xs',
	LOCK_L: 'lock-l',
	LOCK_M: 'lock-m',
	LOCK_S: 'lock-s',
	LOCK_XS: 'lock-xs',
	MINUS_L: 'minus-l',
	MINUS_M: 'minus-m',
	MINUS_S: 'minus-s',
	MINUS_XS: 'minus-xs',
	MORE_L: 'more-l',
	MORE_M: 'more-m',
	MORE_S: 'more-s',
	MORE_XS: 'more-xs',
	PAUSE_L: 'pause-l',
	PAUSE_M: 'pause-m',
	PAUSE_S: 'pause-s',
	PAUSE_XS: 'pause-xs',
	PLAY_L: 'play-l',
	PLAY_M: 'play-m',
	PLAY_S: 'play-s',
	PLAY_XS: 'play-xs',
	PLUS_L: 'plus-l',
	PLUS_M: 'plus-m',
	PLUS_S: 'plus-s',
	PLUS_XS: 'plus-xs',
	STOP_L: 'stop-l',
	STOP_M: 'stop-m',
	STOP_S: 'stop-s',
	STOP_XS: 'stop-xs',
	UNLOCK_L: 'unlock-l',
	UNLOCK_M: 'unlock-m',
	UNLOCK_S: 'unlock-s',
	UNLOCK_XS: 'unlock-xs',
	SETTINGS_L: 'settings-l',
	SETTINGS_M: 'settings-m',
	SETTINGS_S: 'settings-s',
	SETTINGS_XS: 'settings-xs',
	AI_PROCESS: 'ai-process',
	AUTO_SELECTION: 'auto-selection',
	BUSINESS_PROCESS_MONEY: 'business-process-money',
	CALL_BACK: 'call-back',
	COLLAB_ADD: 'collab-add',
	CONTACT_DETAILS: 'contact-details',
	CONTRAST: 'contrast',
	CRM_FIELD_EXCEPT: 'crm-field-except',
	CRM_FIELD_LINKED: 'crm-field-linked',
	CRM_FIELD_SIMPLE: 'crm-field-simple',
	CUSTOMIZATION: 'customization',
	DDOS_ATTACK: 'ddos-attack',
	DELETE_EVENT: 'delete-event',
	DELIVERY_WITH_ITEM: 'delivery-with-item',
	DIGITS_24: 'digits-24',
	DOTS: 'dots',
	FEEDBACK_FORM: 'feedback-form',
	IP_ADDRESS: 'ip-address',
	IP_ADDRESS_CROSSED: 'ip-address-crossed',
	LETTER_SORT_DOWN: 'letter-sort-down',
	LETTER_SORT_UP: 'letter-sort-up',
	LIST_AI: 'list-ai',
	LOGO_ANDROID: 'logo-android',
	LOGO_APPLE: 'logo-apple',
	MULTI_PAGE_FORM: 'multi-page-form',
	NO_SCREENSHOT: 'no-screenshot',
	ONLINE_EVENTS: 'online-events',
	PAYMENT_AND_DELIVERY: 'o-payment-and-delivery',
	PERSONAL_FORM: 'personal-form',
	PRIVATE_MESSAGE: 'private-message',
	PROCESS: 'process',
	PROCESS_STOP: 'process-stop',
	PRODUCTS_CUBE: 'products-cube',
	PRODUCTS_PAYMENT: 'products-payment',
	PRODUCTS_PHOTO: 'products-photo',
	PRODUCTS_SHIRT: 'products-shirt',
	PRODUCTS_QUICK_CRM_FILL: 'products-quick-crm-fill',
	RECEIPT: 'receipt',
	RECEIPT_NOTE: 'receipt-note',
	RECORD_ON: 'record-on',
	REGISTRATION_ON_SITE: 'registration-on-site',
	SCREEN_PHONE: 'screen-phone',
	SERVER_SETTINGS: 'server-settings',
	SPEAKER_ADD: 'speaker-add',
	TEMPLATE_TASK: 'template-task',
	TEXT_FORMAT_BOTTOM: 'text-format-bottom',
	TEXT_FORMAT_CANCEL: 'text-format-cancel',
	TEXT_FORMAT_TOP: 'text-format-top',
	TEXT_FORMAT_TOP_LEFT: 'text-format-top-left',
	TEXT_FORMAT_TOP_RIGHT: 'text-format-top-right',
	TRAINEE: 'trainee',
	USER_PROFILE: 'user-profile',
	VERIFICATION: 'verification',
	VIRTUAL_SERVER: 'virtual-server',
	VIRTUAL_STORAGE: 'virtual-storage',
	VK_LEAD_FORM: 'vk-lead-form',
	WATERMARK: 'watermark',
	WIKI: 'wiki',
	POLL: 'poll',
});

export const Set = Object.freeze({
	...Actions,
	...Social,
	...Main,
	...ContactCenter,
	...CRM,
	...Editor,
	...Special,
	...Animated,
});
